/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Smooth edges, faces, vertices or area</h4>

<p>Smoothens selected edges, vertices, faces, or entire area around selected objects. Repeat to smoothen more.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('703230586')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>U</b>: Smoothen </li>
    <li class='shortcuts__item'><b>Shift-U</b>: Smoothen without moving vertices</li>
</ul>`;

export default function SmoothTooltip() {
    return h('div', { innerHTML: body });
}
